var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-50px h-50px d-flex align-items-center justify-content-center cursor-pointer bg-primary badge SavedResponseGroup rounded-circle",staticStyle:{"position":"absolute","left":"20px","bottom":"20px","z-index":"10000"}},[_c('i',{staticClass:"fad fa-save text-white fs-2x"})])
}]

export { render, staticRenderFns }